var $body,
  $loadMore,
  $grid,
  currentPage = 0,
  PaginationOffset;

$(document).ready(function ($) {
  $loadMore = $('.js-load-more');
  $grid = $('.js-post-grid');

  PaginationOffset = $loadMore.data('paginationOffset');

  $loadMore.click(function (event) {
    console.log('load more')
    event.preventDefault();

    if (!$(this).hasClass('is-loading')) {
      $(this).parent().addClass('is-loading');

      var term_id = $(this).data('term');
      var user_id = $(this).data('user');
      lazyLoadNextPage(term_id, user_id);
    }
  });


  function lazyLoadNextPage(term_id, user_id) {
    console.log('term:' + term_id);
    console.log('user:' + user_id);
    var nextPage = currentPage + 1;

    jQuery.ajax({
      url: linku_ajax_url,
      type: 'post',
      data: {
        action: 'load_more',
        page: nextPage,
        term_id: term_id,
        user_id: user_id
      },
      dataType: 'json',
      success: function (response) {
        currentPage++;

        if (!response.meta.has_next) {
          $loadMore.parent().remove();
        }

        console.log($grid);

        $grid.append(response.html);
        $loadMore.parent().removeClass('is-loading');
        setTimeout( function() {
          $(".c-card--hidden").addClass('show-card');
        },200);

      }
    });
  }
});


// Functions
